module.exports = __webpack_public_path__ + "static/media/SM-ST-1.f38b7050.mp3";